export const DASHBOARD = '/';
